import React, {Component} from 'react';
import {numberFormat} from '../utils/number';
import DataChartComponent from './DataChartComponent';

export default class ContractAmounts extends Component {
    render() {
        let total = this.props.total
            ? this.props.total.total_amount
            : 0.0;

        total = numberFormat(total, 2, ',', '.');

        const heading = `${window.__js_dashboard.total_contract_amount} (${window.__js_dashboard.total}: ${total} €)`;

        return (
            <div className="x_panel">
                <div className="x_title">
                    <h2>
                        <i className="fa fa-angle-right"></i> {heading}
                    </h2>
                    <div className="clearfix"></div>
                </div>
                <div className="x_content">
                    <DataChartComponent data={this.props.data}/>
                </div>
            </div>
        );
    }
}
